(function() {
  // Inject CSS for PhotoSwipe overlay background
  var style = document.createElement('style');
  style.textContent = '.pswp__bg { display: block !important; background: #000 !important; } .pswp { --pswp-bg: #000; }';
  document.head.appendChild(style);

  function initLightbox() {
    if (typeof PhotoSwipeLightbox === 'undefined' || typeof PhotoSwipe === 'undefined') {
      return;
    }
    var galleryLinks = document.querySelectorAll('a.product__gallery-toggle[data-pswp-src]');
    if (!galleryLinks.length) return;

    var dataSource = [];
    galleryLinks.forEach(function(link) {
      dataSource.push({
        src: link.href,
        width: parseInt(link.dataset.pswpWidth) || 1920,
        height: parseInt(link.dataset.pswpHeight) || 1080
      });
    });

    galleryLinks.forEach(function(link, index) {
      link._pswpBound = true;
      link.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var lightbox = new PhotoSwipeLightbox({
          dataSource: dataSource,
          pswpModule: PhotoSwipe,
          bgOpacity: 0.9,
          counter: true,
          arrowKeys: true
        });
        lightbox.on('open', function() {
          var bg = document.querySelector('.pswp__bg');
          if (bg) {
            bg.style.display = 'block';
            bg.style.background = '#000';
          }
        });
        lightbox.init();
        lightbox.loadAndOpen(index);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLightbox);
  } else {
    initLightbox();
  }
})();